<tran-application-detail-dashboard-box [heading]="heading()">
    @if (form(); as form) {
        <form [formGroup]="form" class="flex flex-col gap-8">
            <div class="application-status-detail__field application-status-detail__status">
                @if (isLoading()) {
                    <span class="si-skeleton placeholder-lg w-[60%]" aria-hidden="true"></span>
                } @else if (effectiveReadonly()) {
                    <tran-application-status-indicator [status]="status()" />
                } @else {
                    <tran-application-status-select formControlName="status" />
                }
            </div>
            <div class="application-status-detail__field application-status-detail__award-committee-meeting">
                @if (isAwardCommitteeMeetingLoading()) {
                    <div class="flex items-center gap-2" aria-hidden="true">
                        <span class="si-skeleton rounded-full w-6 h-6"></span>
                        <span class="si-skeleton w-[220px]"></span>
                    </div>
                } @else if (effectiveReadonly()) {
                    <div class="flex flex-row items-center gap-2">
                        <span class="text-2xl element-task-due"></span>
                        <div class="flex gap-2 items-center">
                            <span>
                                {{
                                    'components.application-detail-dashboard.application-status-detail.prefix'
                                        | translate
                                }}
                            </span>
                            <span>{{ formattedAwardCommitteeMeeting() }}</span>
                        </div>
                    </div>
                } @else {
                    <tran-application-award-committee-meeting-select
                        [meetings]="awardCommitteeMeetings()"
                        [isMeetingsLoading]="isAwardCommitteeMeetingsLoading()"
                        [hasMeetingsNextPage]="hasAwardCommitteeMeetingsNextPage()"
                        formControlName="awardCommitteeMeetingId"
                        (loadMoreMeetings)="loadMoreAwardCommitteeMeetings.emit()"
                    />
                }
            </div>
            @if (showMailCommunicationSetting()) {
                <div class="application-status-detail__field application-status-detail__mail-communication">
                    @if (isLoading()) {
                        <span class="si-skeleton placeholder-lg w-[75%]" aria-hidden="true"></span>
                    } @else {
                        <tran-checkbox
                            label="management-application-detail.settings.mail-communication-disabled"
                            labelVariant="secondary"
                            [readonly]="effectiveReadonly()"
                            formControlName="isMailCommunicationDisabled"
                        />
                    }
                </div>
            }
        </form>
    } @else if (isLoading()) {
        <div class="flex flex-col gap-8" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[60%]"></span>
            <div class="flex items-center gap-2">
                <span class="si-skeleton rounded-full w-6 h-6"></span>
                <span class="si-skeleton w-[220px]"></span>
            </div>
        </div>
    } @else if (effectiveReadonly()) {
        <tran-application-status-indicator [status]="status()" />
        @if (isAwardCommitteeMeetingLoading()) {
            <div class="flex items-center gap-2">
                <span class="si-skeleton rounded-full w-6 h-6"></span>
                <span class="si-skeleton w-[220px]"></span>
            </div>
        } @else {
            <div class="flex flex-row items-center">
                <span class="text-2xl element-task-due"></span>
                <div class="flex gap-2 items-center">
                    <span>
                        {{ 'components.application-detail-dashboard.application-status-detail.prefix' | translate }}
                    </span>
                    <span>{{ formattedAwardCommitteeMeeting() }}</span>
                </div>
            </div>
        }
    }
</tran-application-detail-dashboard-box>
